// extracted by css-extract-rspack-plugin
export default {"menuItem":"menu-styles-menuItem-293093fd","itemButton":"menu-styles-itemButton-61d894c7","menuItemSelected":"menu-styles-menuItemSelected-ba8eeda7"};